// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1137":"deviceList","2728":"timeout","7962":"home","8224":"register","8604":"home2","9171":"devicePages"}[chunkId] + "," + {"1137":"b8ae04c23b","2728":"9e28a63f32","7962":"fd9d9e3960","8224":"ff3c790f19","8604":"fd9d9e3960","9171":"ef86acbbfc"}[chunkId] + ".chunk.css";
};